module.exports = __webpack_public_path__ + "static/media/pider.312102f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Heathbot/pider.jpg
// module id = 188
// module chunks = 0